import styled from 'styled-components';

export const InlineRoot = styled.a`
  display: flex;
  align-items: center;
  gap: 1.25rem;
  padding: 1.15rem 1.25rem;
  border-radius: ${({ theme }) => theme.radiusSm};
  font-family: ${({ theme }) => theme.fontFamily};
  background: ${({ theme }) => theme.colors.muted};
  border: 1px solid ${({ theme }) => theme.colors.border};
  text-decoration: none;
  color: inherit;
  transition: background 0.2s, border-color 0.2s, box-shadow 0.2s;
  box-shadow: ${({ theme }) => theme.shadowCard};

  &:hover {
    background: ${({ theme }) => theme.colors.card};
    border-color: rgba(0, 48, 135, 0.14);
    box-shadow: ${({ theme }) => theme.shadowCardHover};
  }

  @media (max-width: 600px) {
    flex-wrap: wrap;
  }
`;

export const Thumb = styled.div`
  width: 5rem;
  height: 5rem;
  border-radius: calc(${({ theme }) => theme.radiusSm} - 8px);
  overflow: hidden;
  flex-shrink: 0;
  border: 1px solid ${({ theme }) => theme.colors.border};

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
`;

export const Body = styled.div`
  flex: 1;
  min-width: 0;
`;

export const TopRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.35rem;
`;

export const AdTag = styled.span`
  padding: 0.15rem 0.45rem;
  border-radius: calc(${({ theme }) => theme.radiusSm} - 14px);
  background: rgba(234, 179, 8, 0.2);
  color: ${({ theme }) => theme.colors.goldForeground};
  font-size: ${({ theme }) => theme.fontClamp.xs};
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

export const Sponsor = styled.span`
  font-size: ${({ theme }) => theme.fontClamp.sm};
  color: ${({ theme }) => theme.colors.mutedForeground};
`;

export const Title = styled.h4`
  margin: 0;
  font-size: ${({ theme }) => theme.fontClamp.base};
  font-weight: 700;
  line-height: 1.3;
  color: ${({ theme }) => theme.colors.foreground};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const Desc = styled.p`
  margin: 0.35rem 0 0;
  font-size: ${({ theme }) => theme.fontClamp.sm};
  line-height: 1.45;
  color: ${({ theme }) => theme.colors.mutedForeground};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const CtaDesktop = styled.span`
  display: none;
  align-items: center;
  gap: 0.4rem;
  padding: 0.6rem 1rem;
  border-radius: calc(${({ theme }) => theme.radiusSm} - 8px);
  background: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.primaryForeground};
  font-size: ${({ theme }) => theme.fontClamp.sm};
  font-weight: 700;
  flex-shrink: 0;

  @media (min-width: 768px) {
    display: inline-flex;
  }
`;
